import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

import {
    clearAdvisorError,
    getActivitiesState,
    getAdvisorsState,
    getCatalogSidebarState,
    getCategoriesState,
    toggleSidebar
} from '../../../../store/slices/catalogSlice';
import CatalogArrowDown from '../../../icons/CatalogArrowDown';
import ActivitiesList from './ActivitiesList';
import CatalogList from './CatalogList';
import styles from './styles.module.scss';

const CatalogGrid = ({ fetchFn, isActivities, isCatalog }) => {
    const dispatch = useDispatch();
    const isTablet = useMediaQuery({ query: '(min-width: 769px)' });
    const isSidebarOpened = useSelector(getCatalogSidebarState);
    const { advisorsList, totalItems: totalAdvisorItems } = useSelector(getAdvisorsState);
    const { list: activitiesList, totalItems: totalActivityItems } = useSelector(getActivitiesState);
    const { activeCategoriesFilters } = useSelector(getCategoriesState);
    const categoriesParams = '?' + activeCategoriesFilters.map((cat) => `category[]=${cat}`).join('&');
    const { t } = useTranslation();

    useEffect(() => {
        fetchFn(categoriesParams);
    }, [categoriesParams]);

    useEffect(() => {
        return () => {
            dispatch(clearAdvisorError());
        };
    }, [dispatch]);

    return (
        <section className={styles.content}>
            <div className={styles.head}>
                {isTablet ? (
                    <div className={styles.result}>
                        {t('catalog.filters.results', {
                            number: isCatalog ? totalAdvisorItems : totalActivityItems
                        })}
                    </div>
                ) : (
                    <button
                        className={styles.filter}
                        onClick={() => {
                            dispatch(toggleSidebar(!isSidebarOpened));
                        }}
                    >
                        {t('catalog.filters.label', { number: activeCategoriesFilters.length })}
                        <CatalogArrowDown />
                    </button>
                )}
            </div>
            {isCatalog && <CatalogList categoriesParams={categoriesParams} />}
            {isActivities && <ActivitiesList categoriesParams={categoriesParams} />}
        </section>
    );
};

export default CatalogGrid;
